function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

//
import * as React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { StyleSheet, css, color as colorAlt } from "../../styles/theme";
import { SvgStar, SvgStarFilled, SvgStarHalfFilled, SvgStarHalfFade } from "../../svg";
import { fade, darken } from "../../utils/colorUtils";
import generateUUID from "../../utils/generateUUID";
var DEFAULT_OPACITY = 0.4;
var ICON_SIZE = 14;
var STAR_SPACING = 2;
var styles = StyleSheet.create({
  StarRating: {
    display: 'inline-block',
    position: 'relative'
  },
  nonEditable: {
    cursor: 'inherit'
  },
  star: {
    cursor: 'inherit'
  },
  starInteractive: {
    cursor: 'pointer'
  },
  starNoninteractive: {
    marginBottom: '0.5rem'
  }
});

function defaultRenderStarFn(_ref) {
  var propColor = _ref.color,
      enableColorOpacity = _ref.enableColorOpacity,
      hoverColor = _ref.hoverColor,
      isEmpty = _ref.isEmpty,
      isFull = _ref.isFull,
      stroke = _ref.stroke,
      isHalf = _ref.isHalf,
      isInteractive = _ref.isInteractive,
      starSpacing = _ref.starSpacing,
      dir = _ref.dir;
  var hoverColorProp = isInteractive ? {
    hoverColor: hoverColor
  } : {};
  var Tag = isFull ? SvgStarFilled : SvgStar;

  if (enableColorOpacity) {
    var color = isEmpty ? '#FFF' : propColor;

    if (isHalf) {
      Tag = SvgStarHalfFade;
    }

    return React.createElement(Tag, _extends({
      style: {
        marginRight: starSpacing,
        verticalAlign: 'text-bottom'
      },
      size: ICON_SIZE,
      color: color,
      dir: dir,
      stroke: stroke,
      "aria-hidden": true
    }, hoverColorProp));
  }

  if (isHalf) {
    Tag = SvgStarHalfFilled;
  }

  return React.createElement(Tag, _extends({
    style: {
      marginRight: starSpacing,
      verticalAlign: 'text-bottom'
    },
    size: ICON_SIZE,
    color: propColor,
    stroke: stroke,
    "aria-hidden": true,
    dir: dir
  }, hoverColorProp));
}

var StarRating =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StarRating, _React$Component);

  function StarRating(props, context) {
    var _this;

    _classCallCheck(this, StarRating);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StarRating).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (rating) {
      return function (ev) {
        if (ev && ev.preventDefault) {
          ev.preventDefault();
          ev.stopPropagation();
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            isInteractive = _this$props.isInteractive,
            name = _this$props.name;

        if (_this.props.isInteractive) {
          _this.setState(function () {
            return {
              rating: rating
            };
          });
        }

        if (isInteractive && onChange) {
          onChange(rating, name);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderStars", function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          limit = _this$props2.limit,
          _this$props2$isIntera = _this$props2.isInteractive,
          isInteractive = _this$props2$isIntera === void 0 ? false : _this$props2$isIntera,
          tabIndexAlt = _this$props2.tabIndex,
          renderStar = _this$props2.renderStar,
          isThemeDark = _this$props2.isThemeDark,
          color = _this$props2.color,
          hoverColor = _this$props2.hoverColor,
          stroke = _this$props2.stroke,
          _this$props2$enableCo = _this$props2.enableColorOpacity,
          enableColorOpacity = _this$props2$enableCo === void 0 ? false : _this$props2$enableCo,
          _this$props2$starSpac = _this$props2.starSpacing,
          starSpacing = _this$props2$starSpac === void 0 ? STAR_SPACING : _this$props2$starSpac,
          dir = _this$props2.dir,
          a11yIdentifier = _this$props2.a11yIdentifier;
      var rating = _this.state.rating;
      var tabIndex = isInteractive ? tabIndexAlt : -1;

      if (!a11yIdentifier && !_this.uuid) {
        _this.uuid = generateUUID();
      }

      return range(limit).reduce(function (total, index) {
        var curRating = index + 1;
        var id = [name, curRating, a11yIdentifier || _this.uuid].filter(function (str) {
          return !!str;
        }).join('_');
        var starInputElem = React.createElement("input", {
          key: id,
          id: id,
          className: "sr-only",
          type: "radio",
          name: name,
          value: curRating,
          checked: rating === curRating,
          onChange: _this.onChange(curRating)
        });
        var starElemProps = {
          onClick: _this.onChange(curRating),
          onKeyPress: _this.onChange(curRating),
          tabIndex: tabIndex
        };
        var decimalPartOfRating = rating % 1;
        var integerPartOfRating = Math.floor(rating);
        var isHalf = integerPartOfRating + 1 === curRating && decimalPartOfRating >= 0.25 && decimalPartOfRating <= 0.75;
        var isFull = curRating < rating + 0.25;
        var isEmpty = !isHalf && !isFull;
        var starSvg = renderStar({
          index: index,
          rating: rating,
          isThemeDark: isThemeDark,
          isFull: isFull,
          isHalf: isHalf,
          isEmpty: isEmpty,
          color: color,
          enableColorOpacity: enableColorOpacity,
          stroke: stroke,
          isInteractive: isInteractive,
          hoverColor: hoverColor,
          starSpacing: starSpacing,
          dir: dir
        });
        var starElem = isInteractive ? React.createElement("label", _extends({
          key: id
        }, css('d-inline-block', styles.starInteractive, styles.star), starElemProps, {
          htmlFor: id
        }), starInputElem, starSvg) : React.createElement("span", _extends({
          key: id
        }, css('d-inline-block', styles.star, styles.starNoninteractive)), starSvg);
        total.push(starElem);
        return total;
      }, []);
    });

    _this.state = {
      rating: props.rating
    };
    _this.uuid = undefined;
    return _this;
  }

  _createClass(StarRating, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('rating' in nextProps && nextProps.rating !== this.state.rating) {
        this.setState(function () {
          return {
            rating: nextProps.rating
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaLabel = _this$props3.ariaLabel,
          isInteractive = _this$props3.isInteractive,
          htmlAttributes = _this$props3.htmlAttributes,
          style = _this$props3.style,
          rootClassName = _this$props3.rootClassName,
          dir = _this$props3.dir;
      return React.createElement("div", _extends({}, htmlAttributes, css(rootClassName, styles.StarRating, !isInteractive && styles.nonEditable), !isInteractive && {
        role: 'img'
      }, {
        style: style,
        dir: dir,
        "aria-label": ariaLabel
      }), this.renderStars());
    }
  }]);

  return StarRating;
}(React.Component);

_defineProperty(StarRating, "propTypes", {
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
  htmlAttributes: PropTypes.object,
  isThemeDark: PropTypes.bool,
  // Name for input element
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  // Actual rating
  rating: PropTypes.number.isRequired,
  tabIndex: PropTypes.number,
  starSpacing: PropTypes.number,
  // If false, the rating will be read only.
  isInteractive: PropTypes.bool,
  // If disabled, we'll use alternative icons and colors for empty and half star
  enableColorOpacity: PropTypes.bool,
  // Total number of stars available
  limit: PropTypes.number,
  onChange: PropTypes.func,
  renderStar: PropTypes.func,
  color: PropTypes.string,
  stroke: PropTypes.string,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  hoverColor: PropTypes.string,
  a11yIdentifier: PropTypes.string
});

_defineProperty(StarRating, "defaultProps", {
  rootClassName: '',
  style: {},
  htmlAttributes: {},
  name: 'StarRating',
  limit: 5,
  rating: 0,
  tabIndex: 0,
  stroke: '#7C6919',
  color: '#F2D049',
  hoverColor: darken('#F2D049', 0.4),
  renderStar: defaultRenderStarFn,
  starSpacing: STAR_SPACING,
  a11yIdentifier: ''
});

export { StarRating as default };